import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import './TestimonialsCarousel.css';

const TestimonialsCarousel = () => {
  const { t } = useTranslation();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);

  const testimonials = [
    {
      id: 1,
      quote: t('testimonial_1_quote'),
      author: t('testimonial_1_author'),
      role: t('testimonial_1_role'),
      image: `${process.env.PUBLIC_URL || ''}/images/image11.jpeg`,
      rating: 5
    },
    {
      id: 2,
      quote: t('testimonial_2_quote'),
      author: t('testimonial_2_author'),
      role: t('testimonial_2_role'),
      image: `${process.env.PUBLIC_URL || ''}/images/image10.jpeg`,
      rating: 5
    },
    {
      id: 3,
      quote: t('testimonial_3_quote'),
      author: t('testimonial_3_author'),
      role: t('testimonial_3_role'),
      image: `${process.env.PUBLIC_URL || ''}/images/image6.jpeg`,
      rating: 5
    }
  ];

  useEffect(() => {
    if (!isAutoplay) return;

    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isAutoplay, testimonials.length]);

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
    setIsAutoplay(false);
    setTimeout(() => setIsAutoplay(true), 6000);
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    setIsAutoplay(false);
    setTimeout(() => setIsAutoplay(true), 6000);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoplay(false);
    setTimeout(() => setIsAutoplay(true), 6000);
  };

  return (
    <section className="testimonials-carousel section-padding">
      <div className="container">
        <div className="testimonials-header fade-up">
          <h2>{t('testimonials_section_title')}</h2>
          <div className="rating-badge">
            <span className="rating-number">4.9</span>
            <div className="rating-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} fill="var(--primary-orange)" color="var(--primary-orange)" />
              ))}
            </div>
          </div>
        </div>

        <div className="carousel-wrapper fade-up">
          <div className="testimonials-container">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`testimonial-slide ${index === currentTestimonial ? 'active' : ''}`}
              >
                <div className="testimonial-content">
                  <p className="testimonial-quote">"{testimonial.quote}"</p>
                  <div className="testimonial-author">
                    <img src={testimonial.image} alt={testimonial.author} />
                    <div className="author-info">
                      <h4>{testimonial.author}</h4>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-arrow prev" onClick={prevTestimonial} aria-label="Previous testimonial">
            <ChevronLeft size={24} />
          </button>
          <button className="carousel-arrow next" onClick={nextTestimonial} aria-label="Next testimonial">
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentTestimonial ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
